import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'

const legacyHashRoutes = new Set(['#/terms', '#/privacy', '#/contact'])

if (legacyHashRoutes.has(window.location.hash)) {
  window.history.replaceState(null, '', window.location.hash.slice(1))
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
